import colors from 'shared/colors';
import { rgbaToHex } from 'shared/lib/color';

const mcColorSet = [
  colors.blue.lighten1,
  colors.yellow.lighten1,
  colors.green.lighten1,
  colors.purple.lighten1,
  colors.orange.lighten1,
  colors.pink.lighten1,
  colors.slate.lighten1,
  colors.red.lighten1,
];

export default (t) => ({
  chart: {
    style: {
      fontFamily: '\'-apple-system\', \'BlinkMacSystemFont\', \'Segoe UI\', \'PingFang SC\', \'Hiragino Sans GB\', '
        + '\'Microsoft YaHei\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
    },
  },
  colors: mcColorSet,
  credits: { enabled: false },
  exporting: { enabled: false },
  legend: {
    enabled: false,
    itemStyle: { color: colors.grey.darken1, fontSize: '12px' },
    itemHoverStyle: { color: colors.grey.darken3 },
    itemHiddenStyle: { color: colors.grey.lighten2 },
    symbolWidth: 8,
    symbolHeight: 8,
    symbolRadius: 2,
    symbolPadding: 6,
    symbolY: 7,
    maxHeight: 80,
    navigation: {
      activeColor: colors.grey.darken2,
      inactiveColor: colors.grey.lighten2,
      style: { color: colors.grey.darken1 },
    },
  },
  title: { text: '' },
  tooltip: {
    useHTML: true,
    backgroundColor: 'transparent',
    borderWidth: 0,
    shadow: false,
    animation: false,
    distance: 24,
    style: { color: colors.grey.darken1, fontSize: '12px' },
  },
  plotOptions: {
    series: {
      animation: false,
      lineWidth: 1.5,
      marker: {
        symbol: 'circle',
        radius: 3,
        enabled: false,
        states: { hover: { enabled: true, radiusPlus: 0 } },
      },
      states: { hover: { lineWidthPlus: 0, halo: { size: 0 } } },
    },
  },
  xAxis: {
    lineColor: rgbaToHex(colors.grey.lighten3),
    lineWidth: 1,
    tickLength: 0,
    labels: { style: { color: colors.grey.darken1, fontSize: '12px' } },
  },
  yAxis: {
    lineColor: rgbaToHex(colors.grey.lighten3),
    lineWidth: 0,
    gridLineColor: colors.grey.lighten3,
    gridLineDashStyle: 'Dot',
    gridZIndex: 0,
    labels: { style: { color: colors.grey.darken1, fontSize: '12px' } },
  },
  lang: {
    decimalPoint: t('highcharts.decimalPoint'),
    thousandsSep: t('highcharts.thousandsSep'),
    months: t('highcharts.months'),
    shortMonths: t('highcharts.shortMonths'),
    weekdays: t('highcharts.weekdays'),
  },
});
